import { Component, OnInit } from "@angular/core";
import { UserService } from "../../services/user/user.service";
import { User } from "../../interfaces/user";
import { MzToastService } from "ng2-materialize";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"],
})
export class ForgotPasswordComponent implements OnInit {
  user = {} as User;
  error: string;
  clicked = false as boolean;
  loading: boolean;
  env: any = environment;
  userErrorMessage: string;
  userSuccessMessage: string;
  inputEmail: string;

  constructor(
    private userService: UserService,
    private toastService: MzToastService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params["expired"]) {
        this.error =
          "Dein Link zum Zurücksetzen des Passworts ist abgelaufen. Bitte setze es erneut zurück.";
        this.userErrorMessage =
          "Dein Link zum Zurücksetzen des Passworts ist abgelaufen. Bitte setze es erneut zurück.";
      }
    });
    setTimeout(() => {
      $("#email").focus();
      $("#email").select();
    }, 100);
  }

  requestPasswordReset() {
    this.loading = true;
    this.clicked = true;
    this.userService
      .requestPasswordReset(this.user)
      .then((response) => {
        this.loading = false;
        // this.toastService.show(' Eine Email zum Zurücksetzen des Passworts wurde an: ' + this.user.email + ' verschickt.', 4000, 'green');
        this.error = null;
        this.inputEmail = "";
        this.userSuccessMessage =
          " Eine E-Mail zum Zurücksetzen des Passworts wurde an " +
          this.user.email +
          " verschickt.";
        console.log(response);
        this.router.navigate(["/login"], {
          queryParams: {
            email: this.user.email,
            registerNotify:
              "Eine E-Mail zum Zurücksetzen des Passworts wurde an " +
              this.user.email +
              " verschickt.",
          },
        });
      })
      .catch((error) => {
        this.loading = false;
        this.clicked = false;
        this.error = error.error.message;
        this.userSuccessMessage = null;
        this.userErrorMessage = "Bitte gib eine gültige E-Mail-Adresse ein.";
      });
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/forgot-password/forgot-password.component.ts